import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPencil2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPencil2"><Path d="M15.5 3.5L4 15L3 21L9 20L20.5 8.5C21.8807 7.11929 21.8807 4.88071 20.5 3.5C19.1193 2.11929 16.8807 2.11929 15.5 3.5Z" stroke="currentColor" strokeLinecap="round"/><Path d="M14.5 5L19 9.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconPencil2;
